import { useEffect, useState } from "react";
import GeneralSwiper from "../shared/swipers/GeneralSwiper";


interface SwiperImage {
  src: string;
  alt: string;
  id: number;
}

const ConstructionDetails = ({ modalData }: any) => {

  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };
  const [swiperImagesData, setSwiperImagesData] = useState<SwiperImage[]>([]);

  useEffect(() => {
    const imagesStructured = modalData?.media?.map((image: any) =>
      image?.pivot?.slug != null && image?.media_type == "image" &&
      ({
        src: process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL + image?.media_name,
        alt: image?.media_name,
        id: image?.id
      })
    );
    setSwiperImagesData(imagesStructured);
  }, [modalData]);
  return (
    <div className="constructionDetails ">
      {swiperImagesData?.length > 0 &&
        <GeneralSwiper images={swiperImagesData} slidesPerView={1.08} FullWidth swiperClass="!py-0 " />
      }
      <div className="flex flex-col lg:flex-row lg:p-[2.5rem] pt-[2rem] px-[1.25rem]  bg-oSilver-100 ">
        <div className="col1 w-[100%] lg:w-[50%] ">
          <h2 className=" text-labelM font-national tracking-[0.00875rem] text-oBlack-60 mb-3">{modalData?.title}</h2>
          <p className="text-bodyL font-minerva-regular mb-3">{formatDate(modalData?.date)}</p>
        </div>
        <div className="col2  w-[100%] lg:w-[50%]">
          <p className=" text-bodyM font-national text-oBlack-60 leading-[120%] tracking-[0.05rem] ">{modalData?.description}</p>
        </div>
      </div>
    </div>
  );
}

export default ConstructionDetails;